import React from 'react';
import { UserOutlined } from '@ant-design/icons';

export default () => {
  return (
    <span className="ml-12">
      <UserOutlined />
    </span>
  );
};
